export const onedriveConfig = {
    clientId: 'ea7c2312-aed7-4b88-9f4a-4dc201765e5f',
    redirectUri: 'http://localhost:3000/home/assessmentSuggestions',
    scopes: ['Files.ReadWrite', 'User.Read'],
    authority: 'https://login.microsoftonline.com/6e0cfcd6-8427-44b2-9b04-3f2aa8f2316d',
};

// export const onedriveConfig = {
//     auth: {
//         clientId: 'ea7c2312-aed7-4b88-9f4a-4dc201765e5f',
//         authority: 'https://login.microsoftonline.com/6e0cfcd6-8427-44b2-9b04-3f2aa8f2316d',
//         redirectUri: 'http://localhost:3000/home/assessmentSuggestions',
//     },
//     cache: {
//         cacheLocation: "sessionStorage",
//         storeAuthStateInCookie: true,
//     }
// };
